// extracted by mini-css-extract-plugin
export default {"container":"DeactivateAccount_container__Hj4un","details":"DeactivateAccount_details__4PZxb"};